import {DefaultTheme} from 'styled-components';

import {PriceMapCarResponseBody} from '@dms/api/core';

import {isOnStock} from './isOnStock';
import {isSoldIn30Days} from './isSoldIn30Days';

export function getChartItemColor(
  theme: DefaultTheme,
  car: PriceMapCarResponseBody,
  isSelected: boolean
): string {
  if (isSelected) {
    return theme.colors.general.accent;
  }
  if (isOnStock(car)) {
    return theme.colors.palettes.orange['60']['100'];
  }
  if (isSoldIn30Days(car)) {
    return theme.colors.palettes.neutral['300']['100'];
  }
  return theme.colors.palettes.neutral['40']['100'];
}
